/* eslint-disable max-len */

import React from 'react';
import ReactGA from 'react-ga';
import Badge from '@material-ui/core/Badge';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import TextField from '@material-ui/core/TextField';
import {I18n} from 'react-redux-i18n';
import {filter, isArray, remove, size} from 'lodash';
import {connect} from 'react-redux';
import AbstractLibraryFilters from './AbstractLibraryFilters';
import ChipsFilter from './ChipsFilter';
import Constrained from './ConstrainedFilters';
import {viewMode} from '../../Library/constants';
import {changeViewMode} from '../../Library/LibraryActions';
import MultipleSelectFilter from './MultipleSelectFilter';
import {filterHiddensOERs} from '../../app/configuration/util';
import AutoCompleteInput from '../../Form/AutoCompleteInput';
import Chips from '../../components/Chips';
import {get, set, toInteger, debounce, merge, forEach, isEmpty, isEqual, cloneDeep, has} from 'lodash';
import ActiveFilterChips from '../component/ActiveFilterChips';
import SearchableMultipleSelectFilter from '../component/SearchableMultipleSelectFilter';
import { FormControl } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { DatePickerChip } from '@peoplenet/vi-components-ui/src/NewLibraryFilter/component/DatePickerChip';
import moment from 'moment';
class DesktopFilters extends AbstractLibraryFilters {
  state = {
    open: false,
    oerTypeFilter: [],
    groupsFilter: [],
    terminalsFilter: [],
    constrainedFilters: {},
    mediaId: '',
    selectedChips: [],
    localConstrainedFilters: {},
    localMediaId: ''
  }

  updateFromProps(props) {
    const {
      oerTypes,
      groupsFilter,
      terminalsFilter,
      oerTypeFilter,
      startTime,
      endTime,
      constrainedFilters,
      filters,
      mediaId,
      chipsFilter
    } = props || this.props;

    const {sortBy} = filters;
    
    this.setState({
      groupsFilter,
      terminalsFilter,
      oerTypeFilter,
      startTime,
      endTime,
      sortBy,
      constrainedFilters,
      oerTypes,
      mediaId,
      localMediaId: mediaId,
      chipsFilter
    });
  }

  componentWillReceiveProps(props) {
    this.updateFromProps(props);
  }

  handleMediaId = ({target}) => {
    this.setState({localMediaId: target.value});
  }

  componentWillMount() {
    this.props.loadGroups();
    this.props.loadOerTypes();
    this.props.loadTerminals();
  }

  updateChipFilter = chips => {
    this.props.updateChipFilter(chips);
    // TODO: add other filters
    this.applyFilter({chipsFilter: chips});
  }

  applyDateFilter = filters => {
    this.applyFilter(filters);
    ReactGA.event({
      category: 'Library Filter',
      action: 'Apply Filters',
      label: 'Apply DateFilter Button'
    });
  }

  applyFilter = filters => {
    const {
      groupsFilter,
      terminalsFilter,
      oerTypeFilter,
      constrainedFilters,
      mediaId,
      startTime,
      endTime,
      sortBy,
      chipsFilter
    } = this.state;

    //const {chipsFilter} = this.props;

    this.props.applyFilter({
      groupsFilter, constrainedFilters, terminalsFilter, oerTypeFilter, chipsFilter, mediaId, startTime, endTime, sortBy, ...filters
    });

    this.props.updateConstrainedFilters(constrainedFilters);
  }

  filterCount() {
    const {
      groupsFilter,
      constrainedFilters,
      terminalsFilter,
      oerTypeFilter,
      mediaId
    } = this.props;

    const count = size(groupsFilter) +
      size(terminalsFilter) +
      size(oerTypeFilter) +
      size(filter(constrainedFilters, i => i === true)) +
      (mediaId ? 1 : 0);

    return count;
  }

  handleOnSelectedAutocomplete = (event, {suggestion}) => {
    if (suggestion.type === 'vehicle') {
      this.addTerms('vehicle', suggestion.name, suggestion.name, true);
    } else if (suggestion.type === 'driver') {
      this.addTerms('driver', suggestion.id, `${suggestion.name} (${suggestion.number})`, true);
    }

    ReactGA.event({
      category: 'Library Filter',
      action: suggestion.type === 'driver' ? 'Driver Name' : 'Vehicle Number',
      label: 'Filter Chips'
    });
  }

  handleOnFetchAutocomplete = value => {
    if (this.fetchTimer) {
      window.clearTimeout(this.fetchTimer);
    }

    this.fetchTimer = window.setTimeout(() => {
      this.props.searchDriverVehicle({text: value});
      this.fetchTimer = null;
    }, 550);
  }

  addTerms = (_term, value, label, isUnique) => {
    let {chipsFilter} = this.props;
    if(!chipsFilter) {
      chipsFilter = [];
    }
    if (isUnique) {
      chipsFilter = this.removeTerms(value, chipsFilter);
    }

    const term = {
      name: _term,
      value,
      label
    };

    chipsFilter = [...chipsFilter, term];

    this.updateChipFilter(chipsFilter);
  }

  removeTerms = (term, terms) => {
    if (terms && terms.length > 0) {
      return terms.filter(o => o.value != term);
    }

    return terms;
  }
  updateChipsFilteredArray = (id) => {
    let filterArray = [...this.state.chipsFilter];
    let filterIndex = filterArray.findIndex((item) => item.value == id);
    if (filterIndex > -1) {
      filterArray.splice(filterIndex, 1);
    }
    this.setState({chipsFilter: filterArray}, function(){
      this.handleOnApply();
    });
  }
  updateFilteredArray = (key, data, id) => {
    let filterArray = {};
    if(isArray(data)){
      filterArray = [...data];
      let filterIndex = filterArray.indexOf(id);
      if (filterIndex > -1) {
        filterArray.splice(filterIndex, 1);
      }
    } else {
      filterArray = cloneDeep(data);
      filterArray[id] && delete filterArray[id];
    }
    this.setState({[key]: filterArray}, function(){
      this.handleOnApply();
    });
  }
  updateActiveFilterChips = (chipIdentifier, id) => {
    switch(chipIdentifier){
      case 'dateTimeFilter':
        this.setState({startTime: moment().startOf('day').subtract(29, 'days').valueOf(), endTime: moment().endOf('day').valueOf(), sortBy: 'desc'}, () => {
          this.handleOnApply();
        });
        break;
      case 'terminals':
        this.updateFilteredArray('terminalsFilter', this.state.terminalsFilter, id);
        break;
      case 'groups':
        this.updateFilteredArray('groupsFilter', this.state.groupsFilter, id);
        break;
      case 'oer':
        this.updateFilteredArray('oerTypeFilter', this.state.oerTypeFilter, id);
        break;
      case 'mediaId':
        this.setState({mediaId: ''}, () => {
          this.handleOnApply();
        });
        break;
      case 'others':
        this.updateFilteredArray('constrainedFilters', this.state.constrainedFilters, id);
        break;
      case 'vehicle':
        this.updateChipsFilteredArray(id);
        break;
      case 'driver':
        this.updateChipsFilteredArray(id);
        break;
      default:
        break;
    }
  }

  handleGroupSelection = value => {
    this.setState({groupsFilter: value}, function(){
      this.handleOnApply();
    });

    ReactGA.event({
      category: 'Library Filter',
      action: 'Groups',
      label: 'Multiple Select'
    });
  }

  handleTerminalsSelection = value => {
    this.setState({terminalsFilter: value}, function(){
      this.handleOnApply();
    });
  
    ReactGA.event({
      category: 'Library Filter',
      action: 'Terminals',
      label: 'Multiple Select'
    });
  }

  handleOerSelection = value => {
    this.setState({oerTypeFilter: value}, function(){
      this.handleOnApply();
    });

    ReactGA.event({
      category: 'Library Filter',
      action: 'OER Type',
      label: 'Multiple Select'
    });
  }

  handleOnClear = () => {
    this.setState({
      open: false,
      constrainedFilters: {},
      mediaId: ''
    }, this.applyFilter);
  }
  handleOnApply = () => {
    this.setState({open: false});
    this.applyFilter({});
  }
  applyConstraintFilters = () => {
    this.setState({constrainedFilters: this.state.localConstrainedFilters, mediaId: this.state.localMediaId}, () => {
      this.setState({open: false});
      this.applyFilter({});
    });
  }
  handleOpen = () => {
    setTimeout(() => {
      try {
          const btnEle = document.getElementById('filter_btn_more');
          if(btnEle && btnEle.getBoundingClientRect() && btnEle.getBoundingClientRect().left){
              let leftPos = btnEle.getBoundingClientRect().left - 50;
              const targetEle = document.getElementsByClassName('libraryfilter__more')[0];
              if(targetEle && leftPos > 0 ){
                  targetEle.style.left = `${leftPos}px`;
              }
              //If the screen resolution is less than 1024, we need to check whether the last dropdown fits within the viewport. If not, then we need to include offset to make it visible. Its temporary fix and need to explore options to handle it in better way in mobile layouts.
              if(!this.isElementInViewport(targetEle) && window.innerWidth < 1024){
                leftPos = leftPos - 180;
                targetEle.style.left = `${leftPos}px`;
              }
          }
      } catch (error) {
          
      }
      
  }, 5);
    this.setState({open: true})
  };
  isElementInViewport = (element) => {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
  handleRequestClose = () => {
    this.setState({open: false, localConstrainedFilters: this.state.constrainedFilters});
    this.updateFromProps();
  }

  handleChangeViewMode = () => {
    this.props.changeViewMode(this.props.viewMode === viewMode.CARD ? viewMode.LIST : viewMode.CARD);
  }

  updateConstrainedFilters = filters => {
    this.setState({localConstrainedFilters: filters});
  }

  onMouseOver = () => this.setState({over: true});
  onMouseOut = () => this.setState({over: false});
  onBlur = () => this.setState({focused: false});
  onFocus = () => this.setState({focused: true});


  render() {
    const {sortBy} = this.props.filters;
    return (
      <div  className="desktopFilterContainer">
        <div className="filtersContainer">
          <div className="librarylist desktopfilters__list">
            <DatePickerChip 
              startTime={this.props.startTime}
              endTime={this.props.endTime}
              sortBy={sortBy}
              handleOnDateApply={this.applyDateFilter}
              showButton={true}
              additionalClass="destopFiltersDialog"
            />
          </div>
          {this.props.terminals && this.props.terminals.length > 0 && <div className="librarylist desktopfilters__list">
            <div id="filterTerminal">
              <SearchableMultipleSelectFilter 
                options={this.props.terminals}
                label={I18n.t('filter.terminal.label')}
                value={this.state.terminalsFilter}
                onChange={this.handleTerminalsSelection}
                isMobile={false}
                type="terminals"
              />
            </div>
          </div>
          }
          {this.props.groups && this.props.groups.length > 0 && <div className="librarylist desktopfilters__list">
            <div id="filterGroup">
              <SearchableMultipleSelectFilter 
                options={this.props.groups}
                label={I18n.t('filter.group.label')}
                value={this.state.groupsFilter}
                onChange={this.handleGroupSelection}
                isMobile={false}
                type="groups"
              />
            </div>
          </div>}
          {this.props.oerTypes && this.props.oerTypes.length > 0 && <div className="librarylist desktopfilters__list">
            <div id="filterOer">
              <SearchableMultipleSelectFilter 
                  options={this.props.oerTypes}
                  label={I18n.t('filter.oer.label')}
                  value={this.state.oerTypeFilter}
                  onChange={this.handleOerSelection}
                  isMobile={false}
                  type="oer"
              />
            </div>
          </div>}
          <div className="librarylist desktopfilters__list">
            <div id="filterMore">
              <FormControl className='librarylist__formcontrol'>
                <Button onClick={this.handleOpen} variant="contained" style={{ width: 'auto', justifyContent: 'left', textTransform: 'capitalize'}} className="chip__datepickerchip filtertype-label"  id={"filter_btn_more"}>
                    {I18n.t('filter.more')}
                    <ArrowDropDownIcon style={{ color: 'white', position: 'absolute', right: '5px'}}/>
                </Button>
              </FormControl>
            </div>
          </div>
          <AutoCompleteInput
            placeholder={I18n.t('filter.VehicleOrDriver.placeholder')}
            list={this.props.driversVehiclesList}
            startFetchLength={3}
            onSelect={this.handleOnSelectedAutocomplete}
            onFetchRequested={this.handleOnFetchAutocomplete}
            isLoading={this.props.isLoading}
            onBlur={this.onBlur}
            onFocus={this.onFocus}
            onMouseOver={this.onMouseOver}
            onMouseOut={this.onMouseOut}
            id="filterVehicleDriver"
          />
          <div style={{display: 'flex', alignItems: "center"}}>
            <IconButton onClick={this.handleChangeViewMode} className="desktopfilters__filtericon" id="viewModeIcon">
              <Icon color="inherit" className="desktopfilters__ddicon">{this.props.viewMode === viewMode.CARD ? 'format_list_bulleted' : 'view_module'}</Icon>
            </IconButton>
          </div>
          <Dialog
            open={this.state.open}
            onClose={this.handleRequestClose}
            BackdropProps={{
              invisible: true
            }}
            classes={{
              root: 'libraryfilter',
              paper: 'libraryfilter__more'
            }}
          >
            <List className="librarylist desktopfilters__list">
              <ListItem>
                <TextField
                  placeholder={I18n.t('filter.mediaId.label')}
                  value={this.state.localMediaId}
                  fullWidth
                  id="filterMediaId"
                  onChange={this.handleMediaId}
                />
              </ListItem>
              <List className="constrained_container">
                <Constrained updateFilters={this.updateConstrainedFilters} {...this.state.constrainedFilters} />
              </List>
              <ListItem className="desktopfilters__actions">
                <Button variant="contained" onClick={this.handleOnClear} id="filterClear" className="btn btn-secondary">{I18n.t('action.clear')}</Button>
                <Button variant="contained" onClick={this.applyConstraintFilters} color="primary" className="btn btn-primary" id="filterApply">
                  {I18n.t('action.apply')}
                </Button>
              </ListItem>
            </List>
          </Dialog>
        </div>
        <ActiveFilterChips 
          terminalsFilter={this.state.terminalsFilter} 
          groupsFilter={this.state.groupsFilter} 
          oerTypeFilter={this.state.oerTypeFilter} 
          sortBy={this.state.sortBy}
          constrainedFilters={this.state.constrainedFilters}
          startTime={this.state.startTime}
          endTime={this.state.endTime}
          mediaId={this.state.mediaId}
          oerTypes={this.state.oerTypes} 
          terminals={this.props.terminals}
          groups={this.props.groups}
          updateActiveFilterChips={this.updateActiveFilterChips}
          clearFilter={this.props.clearFilter}
          chipsFilter={this.state.chipsFilter}
          />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {library} = state;
  return {
    locale: state.i18n.locale,
    viewMode: library.viewMode,
    oerTypes: filterHiddensOERs(state)
  };
}

export default connect(mapStateToProps, {changeViewMode})(DesktopFilters);
